import Net from '../core/libs/Net';

import {
  AppModification,
  TFetchContactsRequest,
  TFetchContactsResponse,
  TMergeAcceptance,
  TPushContactsRequest,
  TPushContactsResponse,
  TUpdateSuggestedMergeRequest,
  TUpdateSuggestedMergeResponse
} from 'TProtocol/contactssync/messages';
import { TAppContact, TAppProvenance, TAuthHeader } from 'TProtocol/common/models';
import { TContactsSyncService } from 'PProtocol/contactssync';
import { IUDBKeyedContact } from '../lib/ContactsDatabase';

const fetchContacts = (
  authHeader: TAuthHeader,
  clientModificationId: string | undefined,
  maxPageSize = 2000
): Promise<TFetchContactsResponse> => {
  const request: TFetchContactsRequest = new TFetchContactsRequest({ maxPageSize, clientModificationId });

  const client: TContactsSyncService.Client = Net.createContactsService();
  return client.fetchContacts(authHeader, request);
};

export interface IUFetchAllContactsResponse {
  allContacts: IUDBKeyedContact[];
  clientModificationId?: string;
  contactIdsToDelete: string[];
}


const addContact = (authHeader: TAuthHeader, contact: TAppContact): Promise<TPushContactsResponse> => {
  const modification = new AppModification();
  modification.newContact = contact;
  modification.provenance = TAppProvenance.MOUSE;

  const request = new TPushContactsRequest({
    modifications: [modification],
    hasMore: false
  });

  const client = Net.createContactsService();
  return client.pushContacts(authHeader, request);
};

const editContact = (authHeader: TAuthHeader, newContact: TAppContact,
  oldContact: TAppContact): Promise<TPushContactsResponse> => {
  const modification = new AppModification();
  modification.newContact = newContact;
  modification.oldContact = oldContact;
  modification.provenance = TAppProvenance.MOUSE;

  const request = new TPushContactsRequest({
    modifications: [modification],
    hasMore: false
  });

  const client = Net.createContactsService();
  return client.pushContacts(authHeader, request);
};

const deleteContact = (authHeader: TAuthHeader, contact: TAppContact): Promise<TPushContactsResponse> => {
  const modification = new AppModification();
  modification.oldContact = contact;
  modification.provenance = TAppProvenance.MOUSE;

  const request = new TPushContactsRequest({
    modifications: [modification],
    hasMore: false
  });

  const client = Net.createContactsService();
  return client.pushContacts(authHeader, request);
};

const updateSuggestedMerges = (authHeader: TAuthHeader, includedContactIds: string[],
  acceptance: TMergeAcceptance): Promise<TUpdateSuggestedMergeResponse> => {

  const request = new TUpdateSuggestedMergeRequest({
    includedContactIds: includedContactIds,
    acceptance: acceptance
  });

  const client = Net.createContactsService();
  return client.updateSuggestedMerges(authHeader, request);
};

export const ContactsSyncApi = {
  fetchContacts,
  updateSuggestedMerges,
  addContact,
  editContact,
  deleteContact
};
